import { render } from "./QuotasModal.vue?vue&type=template&id=7e235867&scoped=true"
import script from "./QuotasModal.vue?vue&type=script&lang=js"
export * from "./QuotasModal.vue?vue&type=script&lang=js"

import "./QuotasModal.vue?vue&type=style&index=0&id=7e235867&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e235867"]])

export default __exports__